import React, { Fragment, FunctionComponent } from 'react';
import { memberId } from '@trello/session-cookie';
import { useFeatureFlag } from '@trello/feature-flag-client';
import {
  getRouteIdFromPathname,
  isBoardRoute,
  getBoardShortLinkFromPathname,
} from '@trello/routes';
import { getLocation } from '@trello/router';

import { useBoardRoutePreloaderQuery } from './BoardRoutePreloaderQuery.generated';
import { isShortLink } from '@trello/shortlinks';

export const RoutePreloader: FunctionComponent = ({ children }) => {
  const isBoardRoutePreloadingEnabled = useFeatureFlag(
    'fep.board_route_preloading',
    false,
  );

  const { pathname } = getLocation();
  const routeId = getRouteIdFromPathname(pathname);
  const isBoard = isBoardRoute(routeId);

  const boardShortLink = isBoard ? getBoardShortLinkFromPathname(pathname) : '';
  const { loading } = useBoardRoutePreloaderQuery({
    variables: {
      boardId: boardShortLink || '',
      memberId: memberId || '',
    },
    skip:
      !memberId ||
      !isBoard ||
      !isBoardRoutePreloadingEnabled ||
      !boardShortLink ||
      !isShortLink(boardShortLink),
  });

  return loading ? null : <Fragment>{children}</Fragment>;
};
